import api, {
  PaginateRequest,
  PaginateResponse,
  ResponseCallback
} from '../services/api.service'
import routeUtil from '../utils/route.util'
import { InventoryData } from './inventory.api'
import { ItemData } from './item.api'
import { PalletData } from './pallet.api'
import { SiteData } from './site.api'
import { UserData } from './user.api'
import { WorkOrderQuantityData } from './workOrderQuantity.api'

export interface WorkOrderData {
  id: number
  suid: number
  siteId: number
  itemId: number
  createdBy: number
  updatedBy: number
  deletedBy?: number
  line: string
  salesOrder?: string
  produceAt: string
  deletedAt?: string
  createdAt: string
  updatedAt: string
  isDeleted: boolean
  code: string
  quantity?: WorkOrderQuantityData
  materialStockout?: boolean
  item?: ItemData
  createdUser?: UserData
  updatedUser?: UserData
  inventories?: InventoryData[]
  site?: SiteData
}

type WorkOrderPaginateResponse = PaginateResponse<WorkOrderData[]>

export interface WorkOrderCreateRequest {
  item?: number
  lineNumber?: string
  salesOrder?: string
  quantity?: number
  produceDate?: string
}

export interface WorkOrderUpdateRequest {
  lineNumber?: string
  salesOrder?: string
  quantity?: number
  adjustmentQuantity?: number
  produceDate?: string
}

interface WorkOrderListBetweenDatesRequst {
  start: string
  end: string
}

const routes = {
  searchByCode: '/workOrders/search/code',
  readLastPallet: '/workOrders/{id}/pallets/last',
  paginate: '/workOrders/paginate',
  delete: '/workOrders/{id}',
  create: '/workOrders',
  read: '/workOrders/{id}',
  update: '/workOrders/{id}',
  listBetweenDates: '/workOrders/listBetweenDates'
}

export default {
  searchByCode (code: string, callback: ResponseCallback<WorkOrderData[]>) {
    const params = { code }
    api.get(routes.searchByCode, params, callback)
  },

  readLastPallet (id: number, callback: ResponseCallback<PalletData>) {
    const url = routeUtil.replaceParams(routes.readLastPallet, { id })
    api.get(url, {}, callback)
  },

  paginate (
    params: PaginateRequest,
    callback: ResponseCallback<WorkOrderPaginateResponse>
  ) {
    api.get(routes.paginate, params, callback)
  },

  delete (id: number, callback: ResponseCallback<WorkOrderData>) {
    const url = routeUtil.replaceParams(routes.delete, { id })
    api.delete(url, {}, callback)
  },

  create (
    payload: WorkOrderCreateRequest,
    callback: ResponseCallback<WorkOrderData>
  ) {
    api.post(routes.create, payload, callback)
  },

  read (id: number, callback: ResponseCallback<WorkOrderData>) {
    const url = routeUtil.replaceParams(routes.read, { id })
    api.get(url, {}, callback)
  },

  update (
    id: number,
    payload: WorkOrderUpdateRequest,
    callback: ResponseCallback<WorkOrderData>
  ) {
    const url = routeUtil.replaceParams(routes.update, { id })
    api.patch(url, payload, callback)
  },

  listBetweenDates (
    params: WorkOrderListBetweenDatesRequst,
    callback: ResponseCallback<WorkOrderData[]>
  ) {
    api.get(routes.listBetweenDates, params, callback)
  }
}
